import axios from "axios";

export const saveTrabajandoPublication = (courseId, data, callback, publicationId = null) => {
  let method, url;
  if (publicationId) {
    method = "patch";
    url = `/courses/${courseId}/trabajando_publications/${publicationId}`;
  } else {
    method = "post";
    url = `/courses/${courseId}/trabajando_publications`;
  }

  var promise = axios({
    method: method,
    url: url,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

// Obtiene el token CSRF desde el meta tag de Rails
const getCSRFToken = () => {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta && meta.getAttribute("content");
};

// // Crear una publicación de Trabajando
// export const saveTrabajandoPublication = (courseId, data, callback) => {
//   axios({
//     method: "post",
//     url: `/courses/${courseId}/trabajando_publications`,
//     data: { trabajando_publication: data },
//     headers: {
//       "X-CSRF-TOKEN": window.Hupe8.token,
//       "Content-Type": "application/json"
//     }
//   })
//     .then(response => callback(null, response))
//     .catch(error => callback(error.response, null));
// };

// Mostrar una publicación de Trabajando
export const fetchTrabajandoPublication = (courseId, publicationId, callback) => {
  axios({
    method: "get",
    url: `/courses/${courseId}/trabajando_publications/${publicationId}`,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  })
    .then(response => callback(null, response))
    .catch(error => callback(error.response, null));
};

// Cambiar el estado de una publicación de Trabajando
export const switchTrabajandoPublicationState = (courseId, publicationId, data, callback) => {
  var promise = axios({
    method: "patch",
    url: `/courses/${courseId}/trabajando_publications/${publicationId}/switch_state`,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
